import baseApi from "store/api/baseApi";
import comparePassword from "utils/comparePassword";

const authManagementApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    userRegister: builder.mutation({
      query: data => {
        return {
          url: `qwikITUser/new/`,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["auth", "user"],
      transformResponse: response => {
        if (response) {
          return response;
        }
      },
    }),
    userLogin: builder.mutation({
      queryFn: async (data, _queryApi, _extraOptions, baseQuery) => {
        try {
          // 1. Fetch all users
          const response = await baseQuery({
            url: `qwikITUser/`,
            method: "GET",
          });

          if (response.error) {
            return { error: response.error };
          }

          const users = response.data;

          console.log("LOGIN DATA:", data);
          console.log("FETCHED USERS:", users);

          // 2. Find user by email (checks both personal_email and official_email)
          const searchEmail = data.email?.toLowerCase().trim();
          const user = users.find(
            u =>
              u.personal_email?.toLowerCase().trim() === searchEmail ||
              u.official_email?.toLowerCase().trim() === searchEmail
          );

          console.log("MATCHED USER:", user);
          console.log("STORED HASH IN DB:", user.password_hash);
          console.log("TYPED PASSWORD:", data.password);

          if (!user) {
            console.error("LOGIN ERROR: User not found for email", searchEmail);
            return { error: { status: 404, data: "User not found" } };
          }

          // 3. Compare password (supports bcrypt, plain text match, or auto-accept if hash missing)
          let isPasswordValid = false;
          if (!user.password_hash || user.password_hash === data.password) {
            isPasswordValid = true;
          } else {
            try {
              isPasswordValid = await comparePassword(
                data.password,
                user.password_hash
              );
            } catch (err) {
              console.error("Bcrypt compare error:", err);
              isPasswordValid = false;
            }
          }

          console.log("PASSWORD VALID?:", isPasswordValid);

          if (!isPasswordValid) {
            console.error("LOGIN ERROR: Password mismatch");
            return { error: { status: 401, data: "Invalid password" } };
          }

          // 4. Success
          return { data: user }; // ✅ Return inside { data }
        } catch (err) {
          console.error(err);
          return { error: { status: 500, data: "Internal server error" } };
        }
      },
    }),
  }),
});

export const { useUserRegisterMutation, useUserLoginMutation } =
  authManagementApi;
